import Vue from "vue";

export default {
    toggleSidebarDesktop (state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile (state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set (state, [variable, value]) {
        state[variable] = value
    },
    add (state, [variable, value]) {
        state[variable].push(value);
    },
    update (state, [value, id]) {
        state.files = state.files.map(file => {
            if(file.id === id)
                return value;
            else
                return file;
        });
        state.user_files = state.user_files.map(file => {
            if (file.created_by == value.created_by) {
                if (file.id == id){
                    return  value;
                }else{
                    return file;
                }
            }
        });

    },
    SET_REGISTER_USER(state, payload){
        state.registerUser = payload;
    },
    SET_LOGIN_USER(state, payload){
        state.loginUser = payload;
    },
    ADD_COUNTRIES(state, payload){
        state.countries = payload;
    },
    ADD_FACTORIES(state, payload){
        state.factories = payload;
    },
    ADD_FACTORY(state, payload){
        state.factories.push(payload);
    },
    ADD_ROLE(state, payload){
        state.roles.push(payload);
    },
    SET_ROLES(state, payload){
        state.roles = payload
    },
    DELETE_ROLE(state, payload){
        let index = state.roles.findIndex(role => role.id == payload);
        state.roles.splice(index, 1)
    },
    UPDATE_ROLE(state, payload){
      state.roles.map(role => {
          if (role.id  == payload.id){
              role.label  = payload.label;
              role.app_type  = payload.app_type;
              role.factory_ids = payload.factory_ids;
              return role;
          }
      })
    },
    SET_CURRENCIES(state, payload){
        state.currencies = payload;
    },
    UPDATE_FACTORY(state, payload){
        state.factories = state.factories.map(factory => {
            if(factory.id === payload.id)
                return payload;
            else
                return factory;
        });
    },
    DELETE_FACTORIES(state, payload){
        for (let index = 0; index < payload.length; index++) {
            const element = payload[index];
            state.factories = state.factories.filter(factory => factory.id != element);
        }
    },
    SET_SKU(state, payload){
        state.sku = payload;
    },
    SET_CURRENCY_SKUS(state, payload) {
        state.currency_skus = payload;
    },
    SET_FACTORY_PRODUCTS(state, payload) {
        state.factory_products = payload;
    },

    ADD_SKU(state, payload){
        state.sku.push(payload);
    },
    EDIT_SKU(state,payload){
        let sku_to_update_index = state.sku.findIndex(sku => sku.id == payload.id);
        //state.sku[sku_to_update_index] = payload.data;
        Vue.set(state.sku, sku_to_update_index, payload.data);
    },
    UPDATE_SKU_PROPS(state,payload){
        let sku_to_update_index = state.sku.findIndex(sku => sku.id == payload.id);

        Vue.set(state.sku, sku_to_update_index, {
            ...state.sku[sku_to_update_index],
            ...payload.data, // Dynamically update all properties in `payload.data`
        });
    },
    FACTORY_SKUS(state, payload){
        state.factory_skus = payload;
    },
    DELETE_SKU(state, payload){
        for (let index = 0; index < payload.length; index++) {
            const element = payload[index];
            state.sku = state.sku.filter(sk => sk.id != element);
        }
    },
    DELETE_FACTORY_SKU(state, payload){
        state.factory_skus = state.factory_skus.filter(sku => sku.id != payload);
    },
    SET_STEPS(state, payload){
        state.steps = payload;
    },
    ADD_STEPS(state, payload){
        state.steps.push(payload);
    },
    DELETE_STEP(state, payload){
        state.steps = state.steps.filter(step => step.id != payload);
    },
    SET_CATEGORIES(state, payload){
        state.categories = payload;
    },
    SET_DEFAULT_CATEGORIES(state, payload){
        state.default_categories = payload;
    },
    ADD_CATEGORY(state, payload){
        state.categories.push(payload);
    },
    UPDATE_CATEGORY(state, payload){
        let index = state.categories.findIndex(category => category.id == payload.id);
        Vue.set(state.categories, index, payload)
    },
    DELETE_CATEGORY(state, payload){
        for (let index = 0; index < payload.length; index++) {
            const element = payload[index];
            state.categories = state.categories.filter(item => item.id != element);
        }
    },
    SET_ERRORS(state, payload){
        state.errors = payload;
    },
    SET_USERS(state, payload){
        state.users = payload;
    },
    ADD_USER(state, payload){
        state.users.push(payload)
    },
    TOTAL_PAGES(state, payload){
        state.total_pages = payload;
    },
    DELETE_USER(state, payload){
        let index = state.users.findIndex(user => user.id == payload);
        state.users.splice(index, 1)
    },
    UPDATE_USER(state, payload){
        state.users.filter(user => {
            if(user.id == payload.id){
                user.name = payload.name;
                user.email = payload.email;
                user.roles[0].id = payload.roles[0].id;
                user.roles[0].name = payload.roles[0].name;
                user.store = payload.store
                user.role_name = payload.role_name
                user.factories = payload.factories
                return user;
            }
        })
    },
    ADD_MODULE(state, payload){
        state.permission_modules.push({id:payload.id,'label':payload.module_name});
    },
    SET_PermissionModules(state, payload){
        state.permission_modules = payload;
    },
    SET_PARENT_LABELS(state, payload){
        if (payload.override == 1) {
            state.parent_labels.push({id: payload.id, 'label': payload.name});
        }
        else {
            state.parent_labels = payload;
        }
    },
    ADD_PERMISSION(state, payload){
        state.permissions.push(payload);
    },
    SET_PERMISSIONS(state, payload){
        state.permissions = payload;
    },
    UPDATE_PERMISSION(state, payload){
        let index = state.permissions.findIndex(permission => permission.id == payload.id);
        state.permissions[index] = payload;
    },
    SET_NAVIGATION(state, payload){
       state.navigation = [payload];
    },
    SET_CURRENT_ROLE_PERMISSIONS(state, payload){
        state.role_permissions = payload;
    },
    SET_FILES(state, payload){
        state.files = payload.data.data;
    },
    SET_USER_FILES(state, payload){
        state.user_files = payload;
    },
    series(state, payload){
        state.series = payload;
    },
    ADD_FILES(state, payload){
        if (state.files.length <=10) {
            state.files.push(payload);
            state.user_files.push(payload);
        }
    },
    SET_CUSTOMERS : (state, payload) =>{
        state.customers = payload
    },
    SET_CUSTOMER_WITH_CURRENT_PRODUCT_ASSIGNED : (state, payload) =>{
        state.customers_with_current_product_assigned = payload
    },
    DELETE_CUSTOMER: (state, payload) =>{
        console.log(payload)
       let ind = state.customers.findIndex(item  => item.id === payload)
        state.customers.splice(ind, 1)
    },
    UPDATE_CUSTOMER: (state, payload) => {
        let ind = state.customers.findIndex(item  => item.id === payload.id)
        state.customers.splice(ind, 1, payload)
    },
    SET_TRANSLATION(state, payload){
        state.translations = payload;
    },
}